/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Filled up Icon component.
 */
export const MaterialFilledUpIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='MaterialFilledUpIcon' size={iconSize} color={iconColor as any} legacyIcon={(
      <svg xmlns='http://www.w3.org/2000/svg' width={iconSize} height={iconSize} viewBox='-7 2 40 20' fill='none'>
        <path xmlns='http://www.w3.org/2000/svg' d='M20 16L12.25 8.26615L4.5 16L20 16Z' fill={iconColor}/>
      </svg>
    )} />
  );
};

MaterialFilledUpIcon.defaultProps = {
  size  : IconSize.large,
  color : Color.grey1
};

export default MaterialFilledUpIcon;
